<template>
  <div>
    <h1>{{location}}</h1>
    <!-- <div v-if="table && table.length === 0">
      <p>
        No Data for selected period
      </p>
    </div> -->
    <div v-if="table && table.length === 0">
      <p>
        Loading...
      </p>
    </div>
    <div v-else-if="store.data[location] && store.data[location].error === true">
      <p>
        Server Error
      </p>
    </div>
    <div v-else-if="table && table.length !== 0">
      
      <div>
        <BasicTableComponent 
          style="width: 400px;"
          :list="table" 
          tableClass="table2excel"
          :tableID="location"
          :zeroStr=0
          :formatters="{
            'TIMESTAMP' : ['d', 'YYYY-MM-DD HH:mm:ss'],
            'QTY' : ['n', '0']
          }"
          :titles="{
            'SITE ID' : 'SITE ID', 
            'TIMESTAMP' : 'TIMESTAMP', 
            'TRANSACTION ID' : 'TRANSACTION ID', 
            'GTIN' : 'GTIN', 
            'PRODUCT DISPLAY NAME' : 'PRODUCT DISPLAY NAME', 
            'TRANSACTION CODE' : 'TRANSACTION CODE', 
            'TRANSACTION TYPE' : 'TRANSACTION TYPE', 
            'QTY' : 'QTY', 
            'UNIT COST' : 'UNIT COST', 
            'UNIT PRICE' : 'UNIT PRICE', 
            'SYSTEM' : 'SYSTEM', 
            'NOTE' : 'NOTE',}"
        />
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'SLGATable',
  inject:['page'],
  props:['location', 'storeName'],
  methods:{
    
  },
  computed:{
    store(){return this.page.$refs[this.storeName]},
    timestamps(){ return this.store.timestamps},
    dateKey(){ return this.timestamps.dateKey},
    isLoading(){
      // let result = this.store.data[this.location].isLoading;
      // result = result || !this.store.data[this.location].inventory;
      // return result
      // return this.store.table.length === 0

    },
    // table(){return this.store.table}
    table(){
      // const location = 'CCS'
      // console.log('table DEBUG', location, this.data[location])
      return [
        ...this.store.data[this.location].openingInventory, 
        ...this.store.data[this.location].purchases, 
        ...this.store.data[this.location].sales, 
        ...this.store.data[this.location].closingInventory,
        ]
    }
  },
}
</script>